// extracted by mini-css-extract-plugin
module.exports = {"bp-min-sm":"(min-width: 520px)","name":"VenueDetails-module--name--79a842","details":"VenueDetails-module--details--d4ed08","widget":"VenueDetails-module--widget--2474a8"};